<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Gửi tin nhắn nhanh" :link="[{ text: 'Gửi tin nhắn nhanh', href: '../fast-post-send' }]" />
    </div>
    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <div class="filter-wrapper">
        <div class="filter-options">
          <v-row>
            <v-col cols="12" md="6">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedDate"
                    label="Ngày"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedDate"
                  color="primary"
                  @input="dateMenu = false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12">
              <GradeClassStudentSelect disableStudentSelect :gradeCol="{ cols: 12, md: 6 }" :classCol="{ cols: 12, md: 6 }" @changed="gradeClassStudentChange" />
            </v-col>
          </v-row>
        </div>
        <div class="filter-submit">
          <v-btn class="search-button" @click="search" outlined :disabled="(requireAnySelected && !hasAnySelection) && this.role.type === 'teacher'">
            Tìm kiếm
          </v-btn>
        </div>
      </div>
    </v-card>
    <v-card outlined class="mx-4 elevation-0">
      <FastPostCreateStudentDataTable ref="student-data-table" @sendPost="sendPost" />
    </v-card>
    <FastPostCreateReportDialog
      :state="sendDialog"
      :postTos="postTos"
      :gradeId="selectedGrade && selectedGrade.id"
      :selectedDate="selectedDate"
      @close="sendDialog = false"
      @success="onSentSuccess"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'
import moment from 'moment'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import FastPostCreateStudentDataTable from '@/modules/post/FastPostCreateStudentDataTable.vue'
import FastPostCreateReportDialog from '@/modules/post/FastPostCreateReportDialog.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'

export default {
  components: { GradeClassStudentSelect, FastPostCreateStudentDataTable, FastPostCreateReportDialog, Breadcrumbs },
  props: {
    requireAnySelected: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      autoSearched: false,
      sendDialog: false,
      postTos: {},
      selectedDate: moment().format('YYYY-MM-DD'),
      dateMenu: false
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role']),
    hasAnySelection() {
      return (
        (this.selectedGrade && !!get(this.selectedGrade, 'id')) ||
        (this.selectedClass && !!get(this.selectedClass, 'id'))
      )
    }
  },
  watch: {
    selectedGrade: {
      handler(newVal) {
        const gradeId = get(newVal, 'id')
        if (gradeId && this.role && this.role.type === 'teacher' && !this.autoSearched) {
          this.autoSearched = true
          this.search()
        }
      },
      deep: true,
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
    },
    search() {
      if (this.role.type === 'teacher') {
        if (this.requireAnySelected && !this.hasAnySelection) {
          this.$alert.error('Vui lòng chọn ít nhất 1 khối / lớp trước khi tìm kiếm')
          return
        }
      }

      const params = {}
      if (this.selectedGrade) params['grade'] = get(this.selectedGrade, 'id')
      if (this.selectedDate) params['date'] = this.selectedDate
      if (this.selectedClass) {
        if (this.selectedClass.type === 'extraCurriculum') {
          const studentIds = this.selectedClass.students
          params['id_in'] = studentIds
        } else {
          params['currentClass'] = this.selectedClass.id
        }
      }
      this.$refs['student-data-table'].searchStudents(params)
    },
    sendPost({ students, classes, grades, allSchool }) {
      this.postTos = { students, classes, grades, allSchool }
      this.sendDialog = !this.sendDialog
    },
    onSentSuccess(posts) {
      this.sendDialog = false
      if (this.$refs['student-data-table']) {
        this.$refs['student-data-table'].updateMessageContents(posts)
      }
    }
  },
  mounted() {
    const gradeId = get(this.selectedGrade, 'id')
    if (gradeId && this.role && this.role.type === 'teacher' && !this.autoSearched) {
      this.autoSearched = true
      this.search()
    }
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>